module.exports = __webpack_public_path__ + "img/register-v2.e7320d5b.svg";